import './src/shared/styles/index.scss';
import { createOnPreRouteUpdate, wrapRootElement } from './src/shared/gatsby/browser-utils';

export { wrapRootElement };
export const onPreRouteUpdate = createOnPreRouteUpdate();
